const initialState = {
  ondcReportUploadSheetError: "",
  ondcReportUploadSheet: {},
};
export default initialState;
